import React from 'react';
import styled from 'styled-components';

import {
  DEFAULT_PAYMENT_COUNT,
  protectedPrice,
  recommendedPaymentMethod,
  stripeFeeComparison,
} from '../../Config/marketplace';
import { useI18n } from '../../i18n/I18nProvider';

const QuoteRevenuePreview = ({ totalTtc = 0 }) => {
  const { pick, formatCurrency } = useI18n();
  const pricing = protectedPrice(totalTtc);
  const stripeFees = stripeFeeComparison(totalTtc, DEFAULT_PAYMENT_COUNT);
  const recommendedMethod = recommendedPaymentMethod(totalTtc);
  const recommendedStripeFee = recommendedMethod === 'sepa_debit' ? stripeFees.sepaDebit : stripeFees.card;
  const estimatedNet = Math.max(0, pricing.artisanBeforeStripe - recommendedStripeFee);

  return (
    <ProtectedPriceCard aria-live="polite">
      <PriceHeader>
        <div>
          <strong>{pick('Votre revenu estimé avant envoi', 'Your estimated revenue before sending')}</strong>
          <span>{pick('Il se met à jour automatiquement avec le total TTC du devis.', 'It updates automatically with the quote total including tax.')}</span>
        </div>
        <NetBlock><span>{pick('Net estimé', 'Estimated net')}</span><b>{formatCurrency(estimatedNet)}</b></NetBlock>
      </PriceHeader>
      <MoneyFlow>
        <FlowItem><span>{pick('Prix client', 'Client price')}</span><strong>{formatCurrency(pricing.customerTotal)}</strong></FlowItem>
        <FlowArrow>−</FlowArrow>
        <FlowItem><span>{pick('Services LPB', 'LPB services')}</span><strong>{formatCurrency(pricing.platformServiceGross)}</strong></FlowItem>
        <FlowArrow>−</FlowArrow>
        <FlowItem><span>{pick('Traitement bancaire estimé', 'Estimated payment processing')}</span><strong>{formatCurrency(recommendedStripeFee)}</strong></FlowItem>
        <FlowArrow>=</FlowArrow>
        <FlowItem $highlight><span>{pick('Pour vous', 'For you')}</span><strong>{formatCurrency(estimatedNet)}</strong></FlowItem>
      </MoneyFlow>
      <FeeNote>{pick(
        `Estimation bancaire indicative pour ${DEFAULT_PAYMENT_COUNT} paiements : ${formatCurrency(stripeFees.card)} par carte ou ${formatCurrency(stripeFees.sepaDebit)} par prélèvement SEPA.`,
        `Indicative processing estimate for ${DEFAULT_PAYMENT_COUNT} payments: ${formatCurrency(stripeFees.card)} by card or ${formatCurrency(stripeFees.sepaDebit)} by SEPA debit.`,
      )}</FeeNote>
    </ProtectedPriceCard>
  );
};

const ProtectedPriceCard = styled.section`display:grid;gap:.85rem;margin-top:.8rem;padding:1rem;border:1px solid #d9c49f;border-radius:1rem;background:linear-gradient(145deg,#fffaf0,#fff);`;
const PriceHeader = styled.div`display:flex;align-items:flex-start;justify-content:space-between;gap:1rem;>div{display:grid;gap:.2rem;}strong{color:#111;}span{color:#6c6253;font-size:.76rem;line-height:1.45;}@media(max-width:560px){display:grid;}`;
const NetBlock = styled.div`display:grid!important;justify-items:end;gap:.05rem!important;min-width:max-content;span{font-size:.68rem;text-transform:uppercase;}b{color:#111;font-size:1.45rem;white-space:nowrap;}@media(max-width:560px){justify-items:start;}`;
const MoneyFlow = styled.div`display:grid;grid-template-columns:minmax(0,1fr) auto minmax(0,1fr) auto minmax(0,1fr) auto minmax(0,1fr);align-items:center;gap:.4rem;padding:.75rem;border-radius:.85rem;background:#151719;color:#fff;@media(max-width:760px){grid-template-columns:1fr;}`;
const FlowItem = styled.div`display:grid;gap:.1rem;padding:.55rem;border:1px solid ${({ $highlight }) => ($highlight ? 'rgba(226,196,143,.65)' : 'rgba(255,255,255,.12)')};border-radius:.7rem;background:${({ $highlight }) => ($highlight ? 'rgba(192,163,117,.18)' : 'rgba(255,255,255,.04)')};span{color:#c8cdd0;font-size:.65rem;}strong{color:${({ $highlight }) => ($highlight ? '#f1c978' : '#fff')};font-size:.9rem;}`;
const FlowArrow = styled.span`color:#d7bd90;font-weight:900;text-align:center;@media(max-width:760px){display:none;}`;
const FeeNote = styled.small`color:#6c6253;font-size:.7rem;line-height:1.5;`;

export default QuoteRevenuePreview;
